import { Bolt } from '@mui/icons-material';
import { Avatar, Tooltip } from '@mui/material';
import { green, red, yellow } from '@mui/material/colors';
import { TimeOfUsePeriods } from 'switch-shared/types/eskom';
import { TOUColours } from 'switch-shared/utils/time-of-use';

interface Props {
  type: TimeOfUsePeriods;
}

const TOUAvatar = ({ type }: Props) => {
  /* Hooks & Use Effects */

  /* States */

  /* API Calls */

  /* Functions & Functional Components */

  switch (type) {
    case TimeOfUsePeriods.OffPeak:
      return (
        <Tooltip title='Electricity Off-Peak'>
          <Avatar
            sx={{
              bgcolor: green[100],
              width: 27,
              height: 27,
              ml: 0.5,
              mb: 1,
            }}
          >
            <Bolt style={{ color: TOUColours.OffPeak }} fontSize='small' />
          </Avatar>
        </Tooltip>
      );
    case TimeOfUsePeriods.Standard:
      return (
        <Tooltip title='Electricity Standard'>
          <Avatar
            sx={{
              bgcolor: yellow[100],
              width: 27,
              height: 27,
              ml: 0.5,
              mb: 1,
            }}
          >
            <Bolt style={{ color: TOUColours.Standard }} fontSize='small' />
          </Avatar>
        </Tooltip>
      );
    case TimeOfUsePeriods.Peak:
      return (
        <Tooltip title='Electricity Peak'>
          <Avatar
            sx={{
              bgcolor: red[100],
              width: 27,
              height: 27,
              ml: 0.5,
              mb: 1,
            }}
          >
            <Bolt style={{ color: TOUColours.Peak }} fontSize='small' />
          </Avatar>
        </Tooltip>
      );
    default:
      break;
  }
};

export default TOUAvatar;
